namespace Areas.CustomQuery {
    "use strict";

    let formIsInitialized: boolean = false;    

    interface ParameterDefinition {
        parameterName: string;
        parameterDisplayName: string;
        parameterType: string;
        parameterLookupDialog: string;
        propertyValueName: string;
        propertyDisplayName: string;
    }

    export function parameterFormIsInitialized(): boolean {
        return formIsInitialized;
    }

    export function createParameterForm(parameters: Array<ParameterDefinition>): void {
        if (formIsInitialized) {
            $("#ParameterForm").dxForm("dispose");
            formIsInitialized = false;
        }

        if (parameters.length == 0) {
            return;
        }

        createForm();
        createParameters(parameters);
    } 

    function createForm(): void {
        $("#ParameterForm").dxForm({
            minColWidth: 100,
            items: [{
                itemType: "group",
                caption: " ",
                name: "MainGroup",
                colCount: 4,
                items: [{
                    itemType: "empty", 
                    colSpan: 4
                }]
            }],
            onInitialized: function(e) { formIsInitialized = true; }   
        });
    }

    function createParameters(parameters: Array<ParameterDefinition>): void {
        const form = $("#ParameterForm").dxForm("instance");
        const mainGroup = form.itemOption("MainGroup");

        form.option("parameterList", parameters.map(item => item.parameterName));
        parameters.forEach(parameter => addParameterToForm(mainGroup, parameter));
        form.repaint();
    }
    
    function addParameterToForm(mainGroup: any, parameter: ParameterDefinition): void {
        const isDialog = Areas.isNotEmpty(parameter.parameterLookupDialog);
        
        if (isDialog) {
            addDialogBox(mainGroup, parameter)
        } else {
            addInputBox(mainGroup, parameter);
        }
    }

    function addInputBox(mainGroup: any, parameter: ParameterDefinition): void {
        const item = getItem(parameter);
        mainGroup.items.push(item);
    }

    function getEditorType(parameterType: string): string {
        const editorTypeMap = {} as IDictionary;
        editorTypeMap["string"] = "dxTextBox";
        editorTypeMap["integer"] = "dxNumberBox";
        editorTypeMap["date"] = "dxDateBox";

        return editorTypeMap[parameterType];     
    }
    
    function getItem(parameter: ParameterDefinition): any {
        return {
            label: {text: parameter.parameterDisplayName},
            dataField: parameter.parameterName,
            editorType: getEditorType(parameter.parameterType),
            colSpan:4
        };
    }

    function addDialogBox(mainGroup: any, parameter: ParameterDefinition): void {
        const item = {
            label: {text: parameter.parameterDisplayName},
            editorType: "dxTextBox",
            name: parameter.parameterName + "Display",
            disabled: true,
            colSpan:3
        };

        mainGroup.items.push(item);   
        
        const button = {
            colSpan: 1,
            template: function(data, element) {
                var div = document.createElement("div");
                element.get(0).appendChild(div);                
                $(div).dxButton({
                    text: "Select",
                    type: "success", 
                    onClick: function(e: any) {
                        createDialog(parameter);
                    }
                })
            }
        };

        mainGroup.items.push(button);          
    }
    
    function createDialog(parameter: ParameterDefinition): void {
        switch (parameter.parameterLookupDialog) {
            
            default:
                break;
        }
    }

    function closeHandler(parameter: ParameterDefinition) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
                    
            const form = $("#ParameterForm").dxForm("instance");
            const editor = form.getEditor(parameter.parameterName + "Display");
            editor.option("value", data[parameter.propertyDisplayName]);

            const formData = form.option("formData");
            formData[parameter.parameterName] = data[parameter.propertyValueName];
        }
    }
}